import { Injectable } from '@angular/core';

import { BsModalService } from 'ngx-bootstrap/modal';
import { take } from 'rxjs/operators';

import { BlockedSlotEditConfirmationModalComponent } from '../containers/blocked-slot-edit-confirmation-modal/blocked-slot-edit-confirmation-modal.component';
import { EditBlockedSlotMode } from '../models/edit-blocked-slot-confirmation-form.model';

@Injectable({
    providedIn: 'root'
})
export class EditBlockedSlotLauncherService {
    constructor(private bsModalService: BsModalService) {}

    openBlockedSlotEditConfirmation(onCloseCallback: (editMode: EditBlockedSlotMode) => void) {
        const modalRef = this.bsModalService.show(BlockedSlotEditConfirmationModalComponent, {
            id: 2
        });

        modalRef.content.onClose.pipe(take(1)).subscribe((value: EditBlockedSlotMode) => {
            onCloseCallback(value);
        });
    }
}
